import React from "react";
import "./StatusTabs.scss";
import { useSelector } from "react-redux";
import { Sidebar, sidebarClasses, Menu, MenuItem, SubMenu, menuClasses } from 'react-pro-sidebar';
import { AdProtectionIcon, TodayIcon, AnalyticsIcon, BotActivityIcon, OverviewIcon, CurrentIcon, BaslineIcon, AffiliatesIcon, ProtectionTabIcon, InSightsIcon, ReportsIcon } from "../icons";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { IoWarningOutline } from "react-icons/io5";
import validPartnerGuids from "../../../Utils/reportingValidPartners";
const StatusTabs = (props) => {
	const admin = localStorage.getItem("admin") === "true";
	const stateKeys = useSelector(state => state?.websiteDetails?.data?.licenceKeys) ?? [];
	const blue = "rgba(6, 141, 215, 1)";
	const green = "rgba(73, 182, 91, 1)";
	const collapsed = props.collapsed;
	const detectModes = { ...useSelector(state => state.detectModes.data) };
	const [displayAdminMenu, setDisplayAdminMenu] = React.useState(false);
	const navigate = useNavigate();
	const partnerGuid = localStorage.getItem("partner_guid") ?? "";
	

	const { pathname } = useLocation()
	if (pathname === '/' || pathname === '/select' || pathname == '/loading') {
		return null;
	}

	const translateStatus = new Map([
		["off", "Disabled"],
		["detect", "Detecting"],
		["protect", "Protecting"]
	])

	const DotSVG = ({ fillRHS = "grey" }) => (<svg className="StatusTabs-SVG StatusTabs-SVG--dot" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
		<circle opacity="0.5" cx="8" cy="8" r="8" fill={fillRHS} />
		<circle cx="8" cy="8" r="6" fill={fillRHS} />
	</svg>);

	const PieSVG = ({ fillRHS = "grey" }) => (
		<svg className="StatusTabs-SVG StatusTabs-SVG--pie" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
			<path id={fillRHS === "grey" ? "" : "Slice-1"} className="StatusTabs-SVG-Slice" fill-rule="evenodd" clip-rule="evenodd" d="M3.20117 1.59888C3.69291 2.46257 4.76241 2.84507 5.70426 2.4545C6.40894 2.16228 7.18322 2 8.00046 2C8.81769 2 9.59198 2.16228 10.2967 2.4545C11.2385 2.84507 12.308 2.46257 12.7997 1.59888C12.5325 1.39821 12.2523 1.21388 11.9606 1.04737C11.6721 0.882677 11.3723 0.73542 11.0628 0.607044C10.1195 0.215889 9.08519 0 8.00046 0C6.91573 0 5.88142 0.215889 4.93816 0.607044C4.62858 0.73542 4.32881 0.882677 4.04028 1.04737C3.74859 1.21388 3.4684 1.39821 3.20117 1.59888Z" fill={fillRHS} />
			<path id={fillRHS === "grey" ? "" : "Slice-2"} className="StatusTabs-SVG-Slice" fill-rule="evenodd" clip-rule="evenodd" d="M14.9528 11.9601C15.1175 11.6716 15.2647 11.3718 15.3931 11.0623C15.7843 10.119 16.0001 9.0847 16.0001 7.99997C16.0001 6.91524 15.7843 5.88093 15.3931 4.93767C15.2647 4.62809 15.1175 4.32832 14.9528 4.03979C14.7863 3.7481 14.6019 3.46791 14.4013 3.20068C13.5376 3.69242 13.1551 4.76193 13.5456 5.70377C13.8379 6.40845 14.0001 7.18273 14.0001 7.99997C14.0001 8.8172 13.8379 9.59149 13.5456 10.2962C13.1551 11.238 13.5376 12.3075 14.4013 12.7993C14.6019 12.532 14.7863 12.2518 14.9528 11.9601Z" fill={fillRHS} />
			<path id={fillRHS === "grey" ? "" : "Slice-3"} className="StatusTabs-SVG-Slice" fill-rule="evenodd" clip-rule="evenodd" d="M12.7997 14.4011C12.308 13.5375 11.2385 13.155 10.2967 13.5455C9.59198 13.8377 8.81769 14 8.00046 14C7.18322 14 6.40893 13.8377 5.70426 13.5455C4.76241 13.155 3.69291 13.5375 3.20117 14.4011C3.4684 14.6018 3.74859 14.7861 4.04028 14.9526C4.32881 15.1173 4.62858 15.2646 4.93816 15.393C5.88142 15.7841 6.91573 16 8.00046 16C9.08519 16 10.1195 15.7841 11.0628 15.393C11.3723 15.2646 11.6721 15.1173 11.9606 14.9526C12.2523 14.7861 12.5325 14.6018 12.7997 14.4011Z" fill={fillRHS} />
			<path id={fillRHS === "grey" ? "" : "Slice-4"} className="StatusTabs-SVG-Slice" fill-rule="evenodd" clip-rule="evenodd" d="M1.59888 12.7993C2.46257 12.3075 2.84507 11.238 2.4545 10.2962C2.16228 9.59149 2 8.81721 2 7.99997C2 7.18274 2.16228 6.40845 2.4545 5.70378C2.84507 4.76193 2.46257 3.69242 1.59888 3.20068C1.3982 3.46791 1.21388 3.7481 1.04737 4.03979C0.882677 4.32832 0.73542 4.62809 0.607044 4.93767C0.215889 5.88093 0 6.91524 0 7.99997C0 9.0847 0.215889 10.119 0.607044 11.0623C0.73542 11.3718 0.882677 11.6716 1.04737 11.9601C1.21388 12.2518 1.39821 12.532 1.59888 12.7993Z" fill={fillRHS} />
		</svg>);

	const toolTipSVG =
		<svg className="StatusTabs-toolTipSVG" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
			<rect opacity="0.05" width="20" height="20" rx="4" fill="white" />
			<path d="M13.3327 7.27371C13.3327 9.26058 12.3003 9.81641 11.4699 10.2619C10.7179 10.6665 10.174 10.958 10.174 12.2761C10.174 12.5364 9.94705 12.7479 9.6678 12.7479C9.38855 12.7479 9.16158 12.5364 9.16158 12.2761C9.16158 10.413 10.1615 9.87584 10.9648 9.44387C11.722 9.03733 12.3203 8.7156 12.3203 7.27469C12.3203 6.0814 11.2785 5.11134 9.99936 5.11134C8.71917 5.11134 7.67845 6.08235 7.67845 7.27469C7.67845 7.535 7.45149 7.74654 7.17224 7.74654C6.89297 7.74654 6.66602 7.53498 6.66602 7.27469C6.66602 5.56078 8.16167 4.16669 10.0004 4.16669C11.836 4.16669 13.3327 5.56083 13.3327 7.27371ZM9.61864 13.8721C9.30068 13.8721 9.04339 14.1119 9.04339 14.4083V14.4638C9.04339 14.7602 9.30069 15 9.61864 15C9.93659 15 10.1939 14.7602 10.1939 14.4638V14.4083C10.1939 14.1129 9.93659 13.8721 9.61864 13.8721Z" fill="white" />
		</svg>;

	const ExpiredSVG = () => (
		<svg className="StatusTabs-SVG" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
			<circle opacity="0.3" cx="8" cy="8" r="7" stroke="#E22937" stroke-width="2" stroke-linecap="round" />
			<path fill-rule="evenodd" clip-rule="evenodd" d="M10.7071 6.70711C11.0976 6.31658 11.0976 5.68342 10.7071 5.29289C10.3166 4.90237 9.68342 4.90237 9.29289 5.29289L8 6.58579L6.70711 5.29289C6.31658 4.90237 5.68342 4.90237 5.29289 5.29289C4.90237 5.68342 4.90237 6.31658 5.29289 6.70711L6.58579 8L5.29289 9.29289C4.90237 9.68342 4.90237 10.3166 5.29289 10.7071C5.68342 11.0976 6.31658 11.0976 6.70711 10.7071L8 9.41421L9.29289 10.7071C9.68342 11.0976 10.3166 11.0976 10.7071 10.7071C11.0976 10.3166 11.0976 9.68342 10.7071 9.29289L9.41421 8L10.7071 6.70711Z" fill="#E22937" />
		</svg>);

	const expired = !(stateKeys.find((key) => key.status === "Active" || key.status === "Trial"));

	const AdminSVG = () => (<svg className="StatusTabs-SVG" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
		<g clip-path="url(#clip0_4645_10040)">
			<path d="M15.9998 7.2327V8.76684C15.9887 9.05749 15.7828 9.3003 15.5032 9.35917L14.2453 9.57623C14.2048 9.58358 14.1644 9.58726 14.1239 9.58358C13.9768 10.1538 13.7487 10.702 13.4471 11.2097C13.4802 11.2355 13.506 11.2649 13.5317 11.298L14.2674 12.3428C14.4255 12.5857 14.3998 12.9057 14.2012 13.1154L13.1161 14.2007C12.9064 14.3994 12.5864 14.4252 12.3437 14.267L11.2991 13.5312C11.266 13.5091 11.2366 13.4797 11.2071 13.4465C10.6959 13.7482 10.1405 13.9763 9.56299 14.1235C9.57403 14.186 9.57403 14.2486 9.56299 14.3111L9.36805 15.4332C9.30184 15.757 9.0223 15.9887 8.69494 15.9998H7.30092C6.97357 15.9887 6.69403 15.757 6.62782 15.4332L6.43288 14.3111C6.42184 14.2486 6.42184 14.186 6.43288 14.1235C5.8554 13.9763 5.30368 13.7482 4.78874 13.4465C4.76299 13.476 4.73357 13.5054 4.69678 13.5275L3.65219 14.2633C3.40943 14.4215 3.08943 14.3957 2.87977 14.1971L1.79471 13.1118C1.59609 12.902 1.57035 12.582 1.72851 12.3428L2.46414 11.298C2.48621 11.2649 2.51563 11.2355 2.54506 11.206C2.24345 10.6983 2.01908 10.1502 1.87196 9.57991C1.8315 9.57991 1.79104 9.57991 1.75058 9.57255L0.492645 9.35549C0.209427 9.29662 0.00345007 9.05381 -0.00390625 8.76317V7.22902C0.00345007 6.93838 0.209427 6.69556 0.492645 6.6367L1.75058 6.41964C1.79104 6.41228 1.8315 6.41228 1.87196 6.41596C2.01908 5.84571 2.24713 5.29754 2.54506 4.78984C2.51563 4.76409 2.48621 4.73098 2.46414 4.69786L1.72851 3.65303C1.57035 3.41021 1.59609 3.09382 1.79471 2.88043L2.87977 1.79513C3.08943 1.59646 3.40943 1.57071 3.65219 1.72891L4.69678 2.46471C4.72989 2.48678 4.75931 2.51621 4.78874 2.54932C5.29632 2.24765 5.84437 2.02323 6.41448 1.87239C6.41448 1.83192 6.41448 1.79145 6.41816 1.75098L6.63517 0.49276C6.69403 0.209476 6.93678 0.00345176 7.22736 -0.00390625H8.76115C9.05173 0.00345176 9.29449 0.209476 9.35334 0.49276L9.57035 1.75098C9.5777 1.79145 9.5777 1.83192 9.57403 1.87239C10.1441 2.01955 10.6922 2.24765 11.1998 2.54932C11.2255 2.51621 11.2549 2.49046 11.2917 2.46471L12.3363 1.72891C12.5791 1.57071 12.8954 1.59646 13.1087 1.79513L14.1938 2.88043C14.3924 3.09014 14.4182 3.41021 14.26 3.65303L13.5244 4.69786C13.5023 4.73098 13.4729 4.76041 13.4398 4.78984C13.7414 5.29754 13.9657 5.84571 14.1166 6.41596C14.157 6.41596 14.1975 6.41596 14.2379 6.41964L15.4959 6.6367C15.7791 6.69556 15.9851 6.93838 15.9924 7.22902L15.9998 7.2327ZM12.5644 8.00161C12.5644 5.48149 10.5193 3.43597 7.99977 3.43964C5.48023 3.43964 3.43517 5.48517 3.43885 8.00529C3.43885 10.5254 5.48023 12.5673 7.99977 12.5673C10.5193 12.5673 12.5644 10.5254 12.5644 8.00529V8.00161Z" fill="white" />
			<path d="M7.99964 8.25939C8.9422 8.25939 9.7063 7.49512 9.7063 6.55233C9.7063 5.60955 8.9422 4.84528 7.99964 4.84528C7.05707 4.84528 6.29297 5.60955 6.29297 6.55233C6.29297 7.49512 7.05707 8.25939 7.99964 8.25939Z" fill="white" />
			<path d="M7.99961 11.0628C9.12145 11.0628 10.1035 10.4631 10.6516 9.57279C9.83501 9.23432 8.94122 9.04669 7.99961 9.04669C7.058 9.04669 6.16421 9.23432 5.34766 9.57279C5.8957 10.4668 6.87409 11.0628 7.99961 11.0628Z" fill="white" />
		</g>
		<defs>
			<clipPath id="clip0_4645_10040">
				<rect width="16" height="16" fill="white" />
			</clipPath>
		</defs>
	</svg>)

	const adminClick = () => {
		setDisplayAdminMenu(!displayAdminMenu)
	}


	const DetectTab = ({ TitleMsg, color, statusType }) => (
		expired ?
			(
				<div className={collapsed ? "StatusTabs StatusTabs--Collapsed" : "StatusTabs"} >
					{<ExpiredSVG />}
					<div className="StatusTabs-textBox" >
						<h6 className="StatusTabs-title"> {TitleMsg}</h6>
						<span className="StatusTabs-span">Status: <b>Expired</b></span>
					</div>
					{/* {toolTipSVG} */}
				</div>
			)
			:
			(
				<div className={collapsed ? "StatusTabs StatusTabs--Collapsed" : "StatusTabs"} >
					{statusType === "Protecting" ? <DotSVG fillRHS={color} /> : <PieSVG fillRHS={color} />}
					<div className="StatusTabs-textBox" >
						<h6 className="StatusTabs-title"> {TitleMsg}</h6>
						<span className="StatusTabs-span">Status: <b>{statusType}</b></span>
					</div>
					{/* {toolTipSVG} */}
				</div>
			)
	);
	const data = [{
		id: 1,
		title: 'Today',
		path: '/wtp/today',
		icon: <TodayIcon />

	},
	{
		id: 2,
		title: 'Bot Threat',
		path: '/wtp/bot-activity',
		icon: <BotActivityIcon />

	},
	{
		id: 3,
		title: 'Performance',
		path: '/wtp/performance',
		icon: <AnalyticsIcon />

	},
	{
		id: 4,
		title: "Baseline",
		path: "/afp/baseline",
		icon: <BaslineIcon />,
	},
	{
		id: 5,
		title: "Current",
		path: "/afp/current",
		icon: <CurrentIcon />
	},
	{
		id: 6,
		title: "Affiliates",
		path: "/affiliates",
		icon: <AffiliatesIcon />,

	},
	]


	const AdminTab = ({ TitleMsg, color, statusType }) => (
		<div className={collapsed ? "StatusTabs StatusTabs--Collapsed StatusTabs--Admin" : "StatusTabs StatusTabs--Admin"} onClick={adminClick} >
			<AdminSVG />
			<div className="StatusTabs-textBox" >
				<h6 className="StatusTabs-title"> {TitleMsg}</h6>
			</div>
			{/* {toolTipSVG} */}
		</div>
	);

	const ReportingTab = () => (
		<div className={collapsed ? "StatusTabs StatusTabs--Collapsed StatusTabs--Admin" : "StatusTabs StatusTabs--Admin"} onClick={() => navigate("/Reporting")} >

			<ReportsIcon />
			<div className="StatusTabs-textBox" >
				<h6 className="StatusTabs-title">Reporting</h6>
			</div>
			{/* {toolTipSVG} */}
		</div>
	);

	const AdminModelBox = () => {
		return (
			<>
				<div className={collapsed ? "StatusTabs-admin-modelbox StatusTabs-admin-modelbox--Collapsed" : "StatusTabs-admin-modelbox"}>
					<Menu menuItemStyles={{
						subMenuContent: {
							backgroundColor: "green",
						},
						root: {
							backgroundColor: "#372e3d",
							borderRadius: "8px",
							marginBottom: "8px",
							padding: "0px"

						},
						icon: {
							width: '50px',
						},
						button: {
							color: '#fff',
							borderRadius: '8px',
							margin: "3px 6px",
							padding: '4px 4px',

							// backgroundColor: "#211728",
							[`&:hover`]: {
								backgroundColor: "#211728",
								fontWeight: 'bolder'
							},
							[`&.${menuClasses.open}`]: {
								background: "none",
							},

							[`&.${menuClasses.active}`]: {
								backgroundColor: '#ffffff',
								color: '#342343',
								padding: '4px 4px',

								[`.svg-shape`]: {
									stroke: "black"
								},
								[`.svg-shape-other`]: {
									stroke: "black"
								}
							},

						},
					}}>

						{data.map((item) => {
							let active = pathname == item.path;

							return <MenuItem active={active} icon={item.icon} component={<Link to={item.path} />}>{item.title}</MenuItem>

						})
						}


					</Menu>
				</div>
			</>
		)
	}

	return (
		<div className="StatusBox">
			<div className={collapsed ? "StatusTabs ThreatBox StatusTabs--Collapsed" : "StatusTabs ThreatBox"} onClick={() => { navigate("/threat"); }} >
				<IoWarningOutline />
				<div className="StatusTabs-textBox" >
					<h6 className="StatusTabs-title">Threat Intelligence</h6>
					<span className="StatusTabs-span">Curated Threat Reports</span>
				</div>
			</div>
			<DetectTab TitleMsg="Web Threat Protection" color={detectModes.wtp_status === "off" ? "grey" : green} statusType={translateStatus.get(detectModes.wtp_status)} />
			<DetectTab TitleMsg="Ad Protection" color={detectModes.afp_status === "off" ? "grey" : blue} statusType={translateStatus.get(detectModes.afp_status)} />
			{validPartnerGuids.has(partnerGuid) && <ReportingTab />}
			{admin && <AdminTab TitleMsg="Administrator Mode" color="red" />}
			{displayAdminMenu && <AdminModelBox />}
		</div>
	);
};

export default StatusTabs;